import ServerError from '@package/components/ErrorPages/Error/ServerError';

export default ServerError;
